import React, {useEffect, useState} from 'react';

interface PopupProps {
    popupOpen: boolean;
    setPopupOpen: (skip: boolean) => any;
}

export function Popup(props: PopupProps) {

    return(
        <div>
            {props.popupOpen ?
                <div className={"popup"}>
                    <div className={"popup-inner"}>
                        <h3>&#9432; FAQ</h3>
                        <h2>What is this?</h2>
                        <ul>
                            <li key={"1"}>capta</li>
                        </ul>
                        <h2>Where can I send feedback?</h2>
                        <ul>
                            <li key={"2"}>No</li>
                        </ul>
                        <div style={{float: "right"}}>
                            <button className={"yesbtn"} onClick={e => {props.setPopupOpen(false)}}>Oke</button>
                        </div>

                    </div>

                </div>
                : <div></div>}
        </div>
    )
}
